import {ErrorHandler, inject} from '@angular/core';
import {signalStore, withState} from '@ngrx/signals';
import {Events, on, withEventHandlers} from '@ngrx/signals/events';
import {withGlitchTracking, withStorageSync, withTrackedReducer} from '@oleksandroleniuk/ngrx-toolkit';
import {map, tap} from 'rxjs';
import {ClientIdUpdatedEvent, CountryIdentifiedEvent, ErrorEvent} from './events/core.events';
import {withDevTools} from './ngrx.utils';

const stateName = 'rootArea';

export interface IRootState {
  clientId: string;
  countryCode: string;
}

export const initialState: IRootState = {
  clientId: '',
  countryCode: '',
};

export const RootStore = signalStore(
  {providedIn: 'root'},
  withDevTools(stateName, withGlitchTracking()),
  withState(initialState),
  withStorageSync({key: 'rootArea', select: ({clientId}) => ({clientId})}),
  withEventHandlers((_, events = inject(Events), errorHandler = inject(ErrorHandler)) => ({
    error$: events.on(ErrorEvent).pipe(
      map(action => action.payload),
      tap(error => errorHandler.handleError(error))
    ),
  })),
  withTrackedReducer(
    on(ClientIdUpdatedEvent, ({payload: {clientId}}) => ({clientId})),
    on(CountryIdentifiedEvent, ({payload: {countryCode}}) => ({countryCode}))
  )
);
